import { Block, DocletContent } from './types'

/**
 * The title of the doclet's first Title block, which names the doclet unless
 * an explicit name is set in document settings. Null when there's no Title
 * block or the first one is blank.
 *
 * Mirrors the API's ShareDoclet.displayName rule (user-api
 * ShareDocletService/shared/displayName.ts), applied here to the builder's
 * live content so the name follows the title as it's typed.
 */
export const firstTitleBlockTitle = (
  content: DocletContent | null | undefined
): string | null => {
  const titleBlock = content?.blocks?.find(
    (block): block is Block<'title'> => block.type === 'title'
  )
  const title = titleBlock?.props.title?.trim()
  return title || null
}
